// extracted by mini-css-extract-plugin
module.exports = {"declaration":"G6K1RhPofdpQ7iL3d3vsPQ==","footer":"eQyDjUTxRYWMLVtQxlE9sw=="};